export enum IrisModalContentType {
  TEMPLATE,
  COMPONENT
}
